import {StyleSheet} from 'react-native';
import Metrics from '../../../../Theme/Metrics';

export const topVodCardStyles = StyleSheet.create({
  card: {
    marginBottom: Metrics.verticalScale(11),
    height: Metrics.verticalScale(120),
  },
});
